<template>
    <div class="vantivesMultiplier">
        <div
            class="formRow | row row--start"
            v-for="(v, i) in items"
            :key="i"
        >
            <slot name="formrow" v-bind:item="v" v-bind:i="i"></slot>


            <div class="vantivesMultiplier__actions">
                <button
                    v-if="canRemoveItem()"
                    type="button"
                    class="removeBtn | noselect"
                    @click="onRemoveClick(i)"
                >
                    <span class="visually-hidden">Remove</span>
                </button>

                <button
                    v-if="canAddItem(i)"
                    type="button"
                    class="addBtn | noselect"
                    @click="onAddClick"
                    v-html="addBtnLabel"
                ></button>
            </div>
        </div>
        <button
            v-if="displayStandaloneAddBtn"
            type="button"
            class="addBtn | noselect"
            @click="onAddClick"
            v-html="addBtnLabel"
        ></button>
    </div>
</template>



<script>
export default {

    /* Settings
    --------------------------------------------------------- */

    name: 'Multiplier',


    props: {
        items: { type: Array, required: true },
        min: { type: Number, default: 1 },
        max: { type: Number, default: 10 },
        addBtnLabel: { type: String, default: 'Add' },
    },


    data() {
        return {
        }
    },




    /* Data Handling
    --------------------------------------------------------- */

    computed: {
        displayStandaloneAddBtn() {
            return this.$props.min === 0 && this.items.length === 0
        },
    },


    watch: {
        //
    },




    /* Methods
    --------------------------------------------------------- */

    methods: {
        onAddClick() {
            this.$emit('add-item')
        },


        onRemoveClick(index) {
            this.$emit('remove-item', { index })
        },

        canRemoveItem() {
            return this.$props.min > 0 ? this.items.length > 1 : this.items.length > 0
        },

        canAddItem(i) {
            return i === this.items.length - 1 && this.items.length < this.$props.max
        },
    },

}

</script>
